import React from "react";
import { Box, Typography } from "@mui/material";
import WorkOrderVisits from "./WorkorderVisits"; // Relative path inside the same folder

/**
 * VisitsTab Component
 *
 * Displays the visit records and visit submission section for the work order.
 *
 * @param {string|number} work_order_id - The ID of the current work order
 * @param {string|number} currentUserId - The currently logged-in user's ID
 */
const VisitsTab = ({ work_order_id, currentUserId }) => {
  return (
    <Box sx={{ p: 2 }}>
      {/* Title/Header */}
      <Typography variant="h6" sx={{ mb: 2 }}>
        Work Order Visits
      </Typography>

      {/* Renders the internal visits table/form */}
      <WorkOrderVisits
        work_order_id={work_order_id}
        currentUserId={currentUserId}
      />
    </Box>
  );
};

export default VisitsTab;
